export default __webpack_public_path__ + "static/media/ice-cream-sandwich.fa9ffaec.jpg";